import { Component, OnInit } from '@angular/core';
// import { barChartmulti } from 'app/shared/data/ngxChart';
import * as chartsData from '../../../../../shared/configs/ngx-charts.config';
import { ApiService } from 'app/shared/services/api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import  * as  util  from 'app/shared/util/util';
import { ActivatedRoute } from '@angular/router';

export var barChartmulti = [
  {
    name:'',
    series: [
      {
        name: '',
        value: ''
      }
    ]
  }
]
@Component({
  selector: 'app-course-reports-chart',
  templateUrl: './course-reports-chart.component.html',
  styleUrls: ['./course-reports-chart.component.scss']
})
export class CourseReportsChartComponent implements OnInit {
  barChartmulti:any = barChartmulti

   //Bar Charts
   barChartView: any[]=[] ;

   // options
   barChartShowYAxis = chartsData.barChartShowYAxis;
   barChartShowXAxis = chartsData.barChartShowXAxis;
   barChartGradient = chartsData.barChartGradient;
   barChartShowLegend = chartsData.barChartShowLegend;
   barChartShowXAxisLabel = chartsData.barChartShowXAxisLabel;
   barChartXAxisLabel = "Total Enrollments";
   barChartShowYAxisLabel = chartsData.barChartShowYAxisLabel;
   barChartYAxisLabel = "College";
   barChartColorScheme = chartsData.barChartColorScheme;

  startDate :any
  endDate:any
  public rows:any = [];
 
  months=util.monthsList()
  yearsList=util.yearsList(10)
  selectedMonth:any=new Date().getMonth()+1;
  selectedYear:any=new Date().getFullYear();
  currentUrl:any;
  constructor(public apiService:ApiService,
    private spinner: NgxSpinnerService,private activatedRoute : ActivatedRoute,
    ) { 
      this.currentUrl=this.activatedRoute.snapshot.routeConfig.path
    Object.assign(this, { barChartmulti})
  }

  ngOnInit(): void {
    if(this.currentUrl ==='course-reports'){
      this.getReports()
    }
    if(this.currentUrl ==='course-reports2'){
      this.activatedRoute.queryParamMap.subscribe((params) => {
        this.selectedMonth = params.get('month');
        this.selectedYear = params.get('year');
        this.getReports()
      });
    }
    
  }

  
  getReports() {
    this.spinner.show(undefined, {
      type: 'ball-triangle-path',
      size: 'medium',
      bdColor: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      fullScreen: true
    });
  
    this.apiService.getCourseReportsMonthYear(this.selectedMonth,this.selectedYear).subscribe((res: any) => {
      
      this.rows = res?.data?.items;
      this.spinner.hide();
      if(this.currentUrl ==='course-reports'){
        // Format data for the chart
        this.barChartmulti = this.rows.reduce((formattedData, item) => {
          item.colleges.forEach(college => {
            const existingEntry = formattedData.find(entry => entry.name === college.collegeName);
            if (existingEntry) {
              // Course name already exists, add series data
              existingEntry.series.push({
                name: item.month,
                value: item.totalCount
              });
            } else {
              // New course name, create a new entry
              formattedData.push({
                name: college.collegeName,
                series: [{
                  name: item.month,
                  value: college.count
                }]
              });
            }
          });

          return formattedData;
        }, []);
      }
      if(this.currentUrl ==='course-reports2'){
        // Format data for the chart
        this.barChartmulti = this.rows.reduce((formattedData, item) => {
          item.colleges.forEach(college => {
            college.courses.forEach(course => {
              const existingEntry = formattedData.find(entry => entry.name === course.courseName);
              if (existingEntry) {
                // Course name already exists, add series data
                existingEntry.series.push({
                  name: item.month,
                  value: course.count
                });
              } else {
                // New course name, create a new entry
                formattedData.push({
                  name: course.courseName,
                  series: [{
                    name: item.month,
                    value: course.count
                  }]
                });
              }
            });
          });
          return formattedData;
        }, []);
      }
    });
  }
  
  onSelect(event) {
    // window.open(`/course/reports?month=${event.label}&year=${this.selectedYear}`, '_blank');
    window.open(`/course/reports`, '_blank');
    // window.open(`/course/course-reports2?month=${this.selectedMonth}&year=${this.selectedYear}`, '_blank');
 }

}
